export default __webpack_public_path__ + "static/media/client-02.2ce227cb.webp";